<template>
  <v-layout row wrap v-if="!selectedLogbook">
    <v-flex d-flex xs12 md12>
      <DashboardTime
        :logtypes="logtypes"
        :logs="logs"
        :datePeriod="datePeriod"
        :fetchingLogs="fetchingLogs"
      />
    </v-flex>
    <v-flex d-flex xs12 md6 v-for="logbook in logtypes" :key="logbook.id">
      <v-card
        class="ma-2 pointer card-rounded"
        flat
        @click="$emit('update:selectedLogbook', logbook.id)"
      >
        <div class="pa-1 dashboard-card__content">
          <v-card-title class="pr-0">
            <v-avatar size="46px" class="mr-3">
              <Icon size="46px" name="clipboard" />
            </v-avatar>
            <div>
              <h3 class="grey--text text--darken-2" v-text="logbook.name" />
            </div>
          </v-card-title>
        </div>
        <v-chip
          class="dashboard-card__chip mb-2 mr-2"
          color="#c6d3c9"
          small
          text-color="grey darken-2"
        >
          <v-avatar class="primary white--text avatar-border">{{
            logbookLogs(logbook).length
          }}</v-avatar>
          Total
        </v-chip>
      </v-card>
    </v-flex>
  </v-layout>
  <AllLogbookStats
    v-else
    :logbooks="logtypes"
    :logs="logs"
    :selectedLogbook="selectedLogbook"
    :resumeTables="resumeTables"
  />
</template>

<script>
import { Logbook } from '../../models/Specialty'
import apexchart from 'vue-apexcharts'
import DashboardTime from './charts/DashboardTime.vue'
import AllLogbookStats from './dashboard/AllLogbookStats.vue'
import { Boolean } from '@vuex-orm/core'
export default {
  components: {
    apexchart,
    DashboardTime,
    AllLogbookStats
  },
  props: {
    logs: { type: Array },
    selectedLogbook: { type: String },
    datePeriod: { type: Number },
    fetchingLogs: { type: Boolean },
    resumeTables: { type: Array }
  },
  data() {
    return {}
  },
  computed: {
    logtypes() {
      return Logbook.query().get()
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    logbookLogs(logbook) {
      return this.logs.filter(log => log.logbook === logbook.id)
    },
    statsData(logbook) {
      return {
        logbookType: logbook.id
      }
    }
  }
}
</script>

<style>
.avatar-border {
  outline: 2px #4eba6f solid;
  outline-offset: -1px;
}
.pointer {
  cursor: pointer;
}
.dashboard-card__chip {
  position: absolute !important;
  bottom: 2px;
  right: 2px;
}

.dashboard-card__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
}
</style>
